import { render, staticRenderFns } from "./header.vue?vue&type=template&id=bbc4c9a8&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=bbc4c9a8&prod&scoped=true&lang=sass"
import style1 from "./header.vue?vue&type=style&index=1&id=bbc4c9a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4c9a8",
  null
  
)

export default component.exports